export const GiftBannerTexts = {
  TagLabel: 'КРЕДИТНАЯ ИСТОРИЯ В ПОДАРОК',
  Header: `Дарим всем, кто\nполучает наши письма`,
  featuresListTexts: ['Покажем все ваши кредиты', 'Рассчитаем кредитный рейтинг', 'Узнайте, какую сумму вам одобрят'],
};
